import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../lib/requester";
// import _ from "lodash";
import moment from "moment";
import _, { toNumber } from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import Autocomplete from "../../component/autocomplete";
import axios from "axios";

class Program extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      expDate: new Date(),
      principalName: "",
      description: "",
      programType: "",
      budgetType: "",
      budget: 0,
      salesTarget: 0,
      programMember: "",
      totalParticipant: 1,
      pphRate: "0",
      participant: [],
      productList: [
        { item_id: "", item_desc: "", item_reff: "", item_budget: "0" },
      ],
      productID: "",
      productDESC: "",
      documentList: [],
      notes: "",
      attachment: [],
      lovBudget: [],
      lovProgramType: [],
      lovDocument: [],
      lovProgramMember: [],
      error: [],
      fileContainer: [],
      productContainer: [],
      lovPPH: [],
      pphType: "Tidak Potong PPh",
      success: "",
      ref_number: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      showParticipant: true,
      total_budget_detail: 0,
    };
    this.onChangeAutocomplete = this.onChangeAutocomplete.bind(this);
  }

  componentDidMount = () => {
    let user = JSON.parse(window.localStorage.getItem("is_user"));
    let principalName = user.org_name;
    this.setState({ principalName: principalName });
    this.setState({ pphRate: 0, pphType: "Tidak Potong PPh" });
    this.getProgramType();
    this.getBudgetType();
    this.getDocumentList();
    this.getProgramMember();
    this.getPPHType();
  };

  getProgramType = () => {
    let url =
      "/api/traces/v1/general/program-type?orgId=" + this.state.user.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramType: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getProgramMember = () => {
    let url = "/api/traces/v1/general/member-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramMember: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getBudgetType = () => {
    let url = "/api/traces/v1/general/budget-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovBudget: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getDocumentList = () => {
    let url =
      "/api/traces/v1/general/document-list?orgId=" + this.state.user.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovDocument: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleInputProduct = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { productList } = this.state;
    productList[index].productName = e.target.value;
    this.setState(productList);
  };

  onSelectProduct = (item, index) => {
    let { productList } = this.state;
    productList[index].item_id = item.value;
    productList[index].item_desc = item.text;

    this.setState(productList);
  };
  onChangeProductReff = (event) => {
    let value = event.target.value;
    let currentindex = event.target.attributes.getNamedItem("currentindex")
      .value;
    let { productList } = this.state;

    productList[currentindex].item_reff = value;
    this.setState(productList);

    let app = this;
    window.setTimeout(() => {
      console.log(currentindex);
      console.log(app.state.productList);
    });
  };

  onChangeProductBudget = (event) => {
    let value = event.target.value.length > 0 ? event.target.value : "";
    let currentindex = event.target.attributes.getNamedItem("currentindex")
      .value;
    let { productList } = this.state;

    productList[currentindex].item_budget = this.thousandSeparator(value);
    this.setState(productList);
  };

  onChangeAutocomplete = (description) => {
    let container = [];
    let app = this;
    // let principalCode = _.find(this.state.lovPrincipal, function (o) {
    //   return parseInt(o.org_id) === parseInt(app.state.org_id);
    // });
    let principalCode = this.state.user.org_initial;
    let param = {
      principalCode: principalCode,
      itemDescription: description,
    };
    return new Promise((resolve) => {
      request.postOracle("/api/orafin/v1/product/list", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.ITEM_DESCRIPTION;
            item.value = item.ITEM_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  renderAddProduct = () => {
    return (
      <div className="form-group row">
        <div className="col-sm-4">
          <Autocomplete
            id="productDefine"
            onchange={this.onChangeAutocomplete.bind(this)}
            principalCode={this.state.user.org_initial}
            onselect={this.onSelectProduct.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            onClick={this.replicateProduct.bind(this)}
            className="btn btn-success"
          >
            +
          </button>{" "}
          &nbsp;
        </div>
      </div>
    );
  };

  renderProduct = () => {
    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-4">
          <Autocomplete
            onchange={this.onChangeAutocomplete.bind(this)}
            currentvalue={item.item_desc}
            currentIndex={index}
            principalCode={this.state.user.org_initial}
            onselect={this.onSelectProduct.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            className="form-control"
            name="itemReff"
            placeholder="Reff ID"
            currentindex={index}
            value={item.item_reff}
            onChange={this.onChangeProductReff.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            className="form-control"
            name="itemBudget"
            placeholder="Budget"
            currentindex={index}
            value={item.item_budget}
            defaultValue=""
            onChange={this.onChangeProductBudget.bind(this)}
          />
        </div>
        <div>
          <button
            type="button"
            onClick={this.replicateProduct.bind(this)}
            className="btn btn-success"
          >
            +
          </button>{" "}
          &nbsp;
          <button
            type="button"
            onClick={() => {
              this.removeProduct(index);
            }}
            className="btn btn-danger"
          >
            -
          </button>
        </div>
      </div>
    ));
  };

  renderProductOld = () => {
    // console.log(this.state.productList)
    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-2">
          <input
            type="text"
            disabled
            className="form-control"
            name="itemDesc"
            // placeholder="Reff ID"
            currentindex={index}
            value={item.item_desc}
            // onChange={this.onChangeProductReff.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            disabled
            className="form-control"
            name="itemId"
            // placeholder="Reff ID"
            currentindex={index}
            value={item.item_id}
            // onChange={this.onChangeProductReff.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            className="form-control"
            name="itemReff"
            placeholder="Reff ID"
            currentindex={index}
            currentvalue={item.item_reff}
            onChange={this.onChangeProductReff.bind(this)}
          />
        </div>
        <div className="col-sm-2">
          <input
            type="number"
            className="form-control"
            name="itemBudget"
            placeholder="Budget"
            currentindex={index}
            currentvalue={item.item_budget}
            defaultValue="0"
            onChange={this.onChangeProductBudget.bind(this)}
          />
        </div>
        <button
          type="button"
          onClick={() => {
            this.removeProduct(index);
          }}
          className="btn btn-danger"
        >
          -
        </button>
      </div>
    ));
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({
      item_id: "", // this.state.productID
      item_desc: "", // this.state.productDESC
      item_reff: "",
      item_budget: "",
    });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList);
  };

  renderDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  replicateDocument = () => {
    let { documentList } = this.state;
    documentList.push({ documentName: "", documentId: "" });
    this.setState(documentList);
  };

  removeDocument = (index) => {
    if (this.state.documentList.length === 1) {
      alert("You must have at least 1 document");
      return false;
    }
    let { documentList } = this.state;
    documentList.splice(index, 1);
    this.setState(documentList);
  };

  handleInputDocument = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { documentList } = this.state;
    documentList[index].documentName = e.target.value;
    this.setState(documentList);
  };

  renderLovBudget = () => {
    return (
      <select
        className="form-control"
        name="budgetType"
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Budget -</option>
        {this.state.lovBudget.map((item, index) => (
          <option value={item.budget_type_id} key={index}>
            {item.budget_type}
          </option>
        ))}
      </select>
    );
  };

  // renderLovPPh = () => {
  //   return (
  //     <select
  //       className="form-control"
  //       name="pphType"
  //       onChange={this.handleChangeInput.bind(this)}
  //     >
  //       <option>- Select Type -</option>
  //       {this.state.lovPPH.map((item, index) => (
  //         <option value={item.pph_type} key={index}>
  //           {item.pph_type}
  //         </option>
  //       ))}
  //     </select>
  //   );
  // };

  renderLovPPh = () => {
    return (
      <select
        className="form-control"
        name="pphType"
        onChange={this.handleChangeInput.bind(this)}
      >
        {this.state.lovPPH.map((item, index) => (
          <option
            value={item.pph_type}
            key={index}
            selected={item.pph_type == "Tidak Potong PPh" ? true : false}
          >
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgram = () => {
    return (
      <select
        className="form-control"
        name="programType"
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Program -</option>
        {this.state.lovProgramType.map((item, index) => (
          <option value={item.prog_type_id} key={index}>
            {item.program_name}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgramMember = () => {
    return (
      <select
        className="form-control"
        name="programMember"
        onChange={this.handleChangeParticipant.bind(this)}
      >
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  };

  renderParticipant = () => {
    if (this.state.showParticipant) {
      return (
        <div className="col-sm-8">
          <input
            type="number"
            className="form-control"
            name="totalParticipant"
            value={this.state.totalParticipant}
            onChange={this.handleChangeInput.bind(this)}
          />
        </div>
      );
    } else {
      return (
        <div className="col-sm-8">
          <input
            type="text"
            disabled
            className="form-control"
            name="totalParticipant"
            value="1"
            onChange={this.handleChangeInput.bind(this)}
          />
        </div>
      );
    }
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if (name === "budget" || name === "salesTarget") {
      value = this.thousandSeparator(value);
    }
    if (name === "pphType" && value === "Tidak Potong PPh") {
      this.setState({ pphRate: 0 });
    }

    this.setState({ [name]: value });
    let app = this;
    window.setTimeout(() => {
      if (name === "org_id") {
        app.getProgramType();
        app.getDocumentList();
      }
      if (name === "pphType" && value === "Tidak Potong PPh") {
        app.setState({ pphRate: 0 });
        app.setState({ pphActive: false });
      }
    }, 100);
  };

  handleChangeParticipant = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    this.setState({ [name]: value });
    this.handleChangeType(value);
  };

  handleChangeType = (value) => {
    let find = _.find(this.state.lovProgramMember, function (o) {
      return o.program_member_id === parseInt(value);
    });
    let type = find ? find.description : "";
    this.setState({ memberId: value, memberType: type });

    let { participant } = this.state;
    participant.customer_id = null;
    participant.participant = null;
    if (type === "Customer") {
      this.setState({ showParticipant: false });
    } else {
      this.setState({ showParticipant: true });
      let app = this;
      window.setTimeout(() => {
        app.setState({ showParticipant: true });
      }, 200);
    }
  };

  thousandSeparator = (value) => {
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    return value;
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  };

  handleExpDate = (date) => {
    this.setState({ expDate: date });
  };

  resetForm = () => {
    this.setState({
      description: "",
      start_date: new Date(),
      end_date: new Date(),
      claim_exp_date: new Date(),
      program_type_id: "",
      budget_type_id: "",
      budget: 0,
      sales_target: 0,
      program_member_id: "",
      total_participant: "",
      notes: "",
      document_list: [],
    });
  };

  validationForm = () => {
    let count = 0;
    let error = [];
    this.setState({ error: [], success: "" });

    let { productList } = this.state;
    let totalAmountProduct = 0;
    let itemBudget = 0;
    productList.forEach((item, index) => {
      itemBudget =
        item.item_budget && item.item_budget.length > 0
          ? item.item_budget
          : "0";
      totalAmountProduct += parseInt(this.removeSeparator(itemBudget));
    });

    if (this.state.principalName === "") {
      error.push("Principal Name is empty");
      ++count;
    } else if (this.state.ref_number.length === 0) {
      error.push("Reference Number is empty");
      ++count;
    } else if (this.state.description.length === 0) {
      error.push("Description is empty");
      ++count;
    } else if (this.state.programType === "") {
      error.push("Please select program type");
      ++count;
    } else if (this.state.budgetType === "") {
      error.push("Please select budget type");
      ++count;
    } else if (this.state.budget === 0 || this.state.budget === "") {
      error.push("Budget is empty");
      ++count;
    } else if (this.state.total_budget_detail > 0) {
      if (
        toNumber(this.state.total_budget_detail) !==
        toNumber(this.removeSeparator(this.state.budget))
      ) {
        error.push(
          "Total budget of products must be 0 or equal with budget program"
        );
        ++count;
      }
    } else if (this.state.salesTarget === 0 || this.state.salesTarget === "") {
      error.push("Sales tartget is empty");
      ++count;
    } else if (this.state.documentList.length === 0) {
      error.push("You must have at least 1 document");
      ++count;
    } else if (this.state.programMember === "") {
      error.push("Please Select Participants");
      ++count;
    } else if (
      totalAmountProduct > 0 &&
      totalAmountProduct !== parseInt(this.removeSeparator(this.state.budget))
    ) {
      error.push(
        "Total budget of products must be 0 or equal with budget program"
      );
      ++count;
    }

    if (count > 0) {
      this.setState({ error: error });
      window.scrollTo(0, 0);
      return false;
    } else {
      return true;
    }
  };

  handleSubmit = () => {
    if (this.validationForm()) {
      let url = "/api/traces/v1/program/insert";

      let app = this;
      this.state.productList.map((item, index) => {
        item.item_budget =
          item.item_budget && item.item_budget.length > 0
            ? app.removeSeparator(item.item_budget)
            : 0;
        return item;
      });
      let param = {
        org_id: this.state.user.org_id,
        description: this.state.description,
        start_date: moment(this.state.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.state.endDate).format("YYYY-MM-DD"),
        claim_exp_date: moment(this.state.expDate).format("YYYY-MM-DD"),
        program_type_id: this.state.programType,
        budget_type_id: this.state.budgetType,
        budget: this.removeSeparator(this.state.budget),
        sales_target: this.removeSeparator(this.state.salesTarget),
        program_member_id: this.state.programMember,
        total_participant: this.state.totalParticipant,
        notes: this.state.notes,
        user_id: this.state.user.user_id,
        document_list: this.state.documentList,
        document_upload: this.state.fileContainer,
        ref_number: this.state.ref_number,
        initial: this.state.user.org_initial,
        product_list: this.state.productList,
        pphType: this.state.pphType,
        pphRate: this.state.pphRate,
        source: "infostep",
        menu: "program",
        function: "create program",
        user_name: this.state.user.username,
      };

      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          let { message } = response.data;
          window.scrollTo(0, 0);
          this.setState({ loading: false, success: message });
          window.setTimeout(() => {
            window.location.reload();
          }, 2000);
        }.bind(this),
        error: function (e) {
          let error = "Failed to submit, please try again";
          this.setState({ loading: false, error: [error] });
        }.bind(this),
      });
    }
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          {this.state.success}
        </div>
      );
    }
  };

  uploadFile = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyTraces("/api/traces/v1/general/upload-file", data, {
      success: function (response) {
        let data = response.data;
        this.setState({ fileContainer: data, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            {/* <Wizzard currentStep="general" /> */}
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                placeholder="Reference Number"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ref_number}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgram()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Description"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovBudget()}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.startDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleStartDate}
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.endDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleEndDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.expDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleExpDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.salesTarget}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                type="number"
                                max="100"
                                disabled={
                                  this.state.pphType === "Tidak Potong PPh"
                                    ? true
                                    : false
                                }
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Claim Documents</h5>
                          <div className="row">{this.renderDocument()}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <h5>Participants</h5>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Participants Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovProgramMember()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Total Participant
                            </label>
                            {this.renderParticipant()}
                            {/* <div className="col-sm-8">
                                                            <input type="number" className="form-control" name="totalParticipant" value={ this.state.totalParticipant } onChange={ this.handleChangeInput.bind(this) } />
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Products</h5>
                          {/* {this.renderAddProduct()} */}
                          {this.renderProduct()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Notes Participants
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                cols="10"
                                rows="5"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                              ></textarea>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Attachment
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="file"
                                className="form-control"
                                onChange={this.uploadFile.bind(this)}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            ></label>
                            <div className="col-sm-8">
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={this.handleSubmit.bind(this)}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Program;
